export class CustomerHelper {
  public static maxContacts = 3;
}
